import { Eraser, Paintbrush, Trash2, X } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

// Renders the admin street tools as native-styled 29px buttons, portaled into
// the bottom-left control group beneath the layers button (see MapView). The
// tool logic and active-mode panels still live in the tool components; these
// buttons only toggle their modes.
interface MapToolsControlProps {
  brushActive: boolean;
  onToggleBrush: () => void;
  eraseActive: boolean;
  onToggleErase: () => void;
  deleteActive: boolean;
  onToggleDelete: () => void;
}

interface ToolButtonProps {
  active: boolean;
  onClick: () => void;
  title: string;
  activeTitle: string;
  Icon: LucideIcon;
  activeColor: string;
}

const ToolButton = ({
  active,
  onClick,
  title,
  activeTitle,
  Icon,
  activeColor,
}: ToolButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    title={active ? activeTitle : title}
    // `!flex` overrides `.maplibregl-ctrl-group button { display: block }`
    // so the icon centers, matching the layers button.
    className={cn(
      "!flex h-[29px] w-[29px] items-center justify-center text-foreground",
      active && "!bg-muted",
    )}
    style={active ? { color: activeColor } : undefined}
  >
    {active ? (
      <X className="h-[18px] w-[18px]" />
    ) : (
      <Icon className="h-[18px] w-[18px]" />
    )}
  </button>
);

export const MapToolsControl = ({
  brushActive,
  onToggleBrush,
  eraseActive,
  onToggleErase,
  deleteActive,
  onToggleDelete,
}: MapToolsControlProps) => (
  <>
    <ToolButton
      active={brushActive}
      onClick={onToggleBrush}
      title="Mark streets complete"
      activeTitle="Exit completion mode"
      Icon={Paintbrush}
      activeColor="#059669"
    />
    <ToolButton
      active={eraseActive}
      onClick={onToggleErase}
      title="Mark streets incomplete"
      activeTitle="Exit incomplete mode"
      Icon={Eraser}
      activeColor="#d97706"
    />
    <ToolButton
      active={deleteActive}
      onClick={onToggleDelete}
      title="Delete streets"
      activeTitle="Exit delete mode"
      Icon={Trash2}
      activeColor="#dc2626"
    />
  </>
);
